"use client"
import { useState } from "react";
import styles from "./NewsletterSignup.module.css";
import { locale } from "@locale";
import CheckboxSvg from "src/components/svg/CheckboxSvg";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import classNames from "classnames";
import { useQuery, type QueryFunction } from "@tanstack/react-query";
import axios, { isAxiosError } from "axios";

//#region [Component]
export default function YulsnNewsletterSignup() {
    const [email, setEmail] = useState("");
    const [isChecked, setIsChecked] = useState(false);

    const { isFetching, isError, refetch, isFetched, error, isSuccess } = useQuery({
        queryKey: ["yulsn-newsletter", email] as const,
        enabled: false,
        retry: false,
        queryFn: submitFn,
    });

    const isFull = email.trim().length > 0;

    const themeStyles = getThemeStyles(styles)

    return <div className={classNames(styles.SNewsletterSignup, themeStyles)}>
        <div>
            <div className={styles.SForm}>
                <input className={styles.SEmailInput} type="email" placeholder={locale.newsletter.emailPlaceholder} name="Email" id="yulsn-EMAIL" aria-label={locale.newsletter.emailPlaceholder} onChange={(e) => setEmail(e.target.value)} />
                <button className={styles.SSubmitButton} type="button" disabled={!isChecked || isFetching} onClick={() => refetch()}>Send</button>
            </div>
        </div>
        {!isSuccess && <div className={styles.SPersonvern} onClick={() => setIsChecked(!isChecked)}>
            <CheckboxSvg className={styles.SCheckboxSvg} isChecked={isChecked} />
            <div className={styles.SLabel}>{locale.newsletter.tosAcceptPreamble} <FilmwebLink className={styles.SPersonvernLink} to="/nyheder/markedsfoerings-samtykke" rel="noopener noreferrer" target="_blank">{locale.newsletter.tosLink}</FilmwebLink></div>
        </div>}
        {!isChecked && isFull && <div className={styles.SError}>{locale.newsletter.tosError}</div>}
        {isSuccess && <div className={styles.SResponse}>
            <h3>Tak for din tilmelding.</h3>
            <p>Vi glæder os til at holde dig opdateret.</p>
        </div>}
    </div>;
}
//#endregion

const submitFn: QueryFunction<unknown, readonly ["yulsn-newsletter", string]> = async (context) => {
    const { signal, queryKey: [, email] } = context;
    const axiosResponse = await axios.request({
        method: "POST",
        url: "https://public.yulsn.io/p/kinodk-nyhedsbrevstilmelding-fra-forsidebox/7f902108371c6c43fb879988034c1bdeba",
        data: {
            Email: email,
        },
        signal
    });
    if (isAxiosError(axiosResponse)) {
        throw axiosResponse;
    }
    return axiosResponse.data;
}